import { render, staticRenderFns } from "./exact-copy-toggle.vue?vue&type=template&id=2b64aa00&scoped=true"
import script from "./exact-copy-toggle.vue?vue&type=script&lang=js"
export * from "./exact-copy-toggle.vue?vue&type=script&lang=js"
import style0 from "./exact-copy-toggle.vue?vue&type=style&index=0&id=2b64aa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64aa00",
  null
  
)

export default component.exports